// extracted by mini-css-extract-plugin
module.exports = {"sectionHeaderWithAction":"index_sectionHeaderWithAction__fw4D_","sectionIndicator":"index_sectionIndicator__3ECdh","sectionTitle":"index_sectionTitle__27OzA"};